<div class="mtx-progress-fill {{'mtx-progress-fill-' + type}}"
     [ngClass]="{'mtx-progress-fill-striped': striped, 'mtx-progress-fill-animated': animate}"
     [ngStyle]="{'width.%': value, 'background-color': foreground, 'color': color}"
     role="progress-fill">
  <ng-content></ng-content>
</div>
